import { AbstractControl } from '@angular/forms';

export class PasswordValidator {

  /**
   * Match two inputs
   * @param first
   * @param second
   * @returns {(AC: AbstractControl) => any}
   * @constructor
   */
  static Match(first, second) {
    return (AC: AbstractControl) => {
      const firstControlValue = AC.get(first).value;
      const secondControlValue = AC.get(second).value;
      if (firstControlValue !== secondControlValue) {
        AC.get(second).setErrors({match: true});
        return;
      } else {
        return null;
      }
    };
  }
}
